<template>
  <div>
    <div class="col-fluid sortRow align-items-center">
      <div class="row">
        <div class="col">
          <h2 class="resultsHeader">
            <slot name="rate-table-title"></slot>
          </h2>
        </div>

        <div v-if="showSortFilter && !isWp" class="col d-none d-sm-block sortDropDown">
          <label class="sortLabel">Sort By</label>
          <select class="form-control" name="sort" v-model="filter.sort">
            <option value="default">Default</option>
            <option value="apy">APY</option>
          </select>
        </div>

        <div class="col d-block d-sm-none sortCol text-right" v-if="!isWp">
          <a href data-toggle="modal" data-target="#sortFilterModal">
            <font-awesome-icon :icon="['fas', 'filter']"></font-awesome-icon> Filter
            <span v-if="showSortFilter">/ Sort</span>
          </a>
        </div>        
      </div>
      <div class="row" v-show="isWp">
       <div class="col-12 ad-disclosure-div-new pr-0">
          <div class="tooltipdata pull-left">             
            <how-da-get-paid></how-da-get-paid> <span style="padding-left: 4px; padding-right: 4px; color: #aaa;">  | </span>  <ad-disclosure></ad-disclosure>      
          </div>
        </div>
      </div>
      <hr class="d-none d-sm-block" />
      <hr class="hr-mobile-seperator d-block d-sm-none row" style="margin-top:1rem" v-if="isWp" />
    </div>

    <div class="rateTableContainer">
      <template v-if="isTopZoneComing">
        <div class="row">
          <div class="col-sm resultsCol">
            <div class="sponsoredResults" v-show="!isWp">
              {{numPlacements}} {{numPlacements > 1 ? 'Sponsored Results' : 'Sponsored Result' }}
              <span class="da-tooltip-span" style="cursor: pointer" :title="addisclosureText">
            <font-awesome-icon :icon="['far', 'question-circle']"></font-awesome-icon>
            </span>                      
            </div>
          </div>
        </div>
         <div class="row" style="margin-top:5px" v-if="!isWp">
          <div class="col-sm resultsCol">
            <div class="sponsoredResults-ad" >
              <how-da-get-paid></how-da-get-paid> 
              </div>              
          </div>  
        </div>
        
        <div class="rateTable col-fluid">
          <template v-if="isExperienceB">
            <!-- Sponsored Ads -->
            <div style="cursor:default;" v-for="(account, index) in sponsoredOnly" v-bind:key="index">
              <rate-table-row
                :account="account"
                :ad="filterPlacement(account.clickUrl)"
                :isWp="isWp"
                :labelCTAButton="labelCTAButton"
                :CTAButtonColor="CTAButtonColor"
                :showDepositAmountAndEstEarning="showDepositAmountAndEstEarning"
                :showAdCopy="showAdCopy"
                :frictionLevel="frictionLevel"
              ></rate-table-row>
              <hr class="hr-separator d-none d-sm-block" />
            </div>

            <!-- Non-sponsored Ads -->
            <h4 v-if="Object.keys(nonSponsoredOnly).length > 0" class="compareToLabel">Compare to:</h4>
            <div style="cursor:default;" v-for="account in nonSponsoredOnly" v-bind:key="account.id">
              <rate-table-row
                :account="account"
                :ad="filterPlacement(account.clickUrl)"
                :isWp="isWp"
                :labelCTAButton="labelCTAButton"
                :CTAButtonColor="CTAButtonColor"
                :showDepositAmountAndEstEarning="showDepositAmountAndEstEarning"
                :showAdCopy="showAdCopy"
                :frictionLevel="frictionLevel"
                :isExperienceB="true"
              ></rate-table-row>
              <hr class="hr-separator d-none d-sm-block" />
            </div>
          
          </template>
          <template v-else>
            <!-- All ads (sponsored, non-sponsored) -->
            <div style="cursor:default;" v-for="(account, index) in topZoneAccounts" v-bind:key="index">
              <rate-table-row
                :account="account"
                :ad="filterPlacement(account.clickUrl)"
                :isWp="isWp"
                :labelCTAButton="labelCTAButton"
                :CTAButtonColor="CTAButtonColor"
                :showDepositAmountAndEstEarning="showDepositAmountAndEstEarning"
                :showAdCopy="showAdCopy"
                :frictionLevel="frictionLevel"
              ></rate-table-row>
              <hr class="hr-separator d-none d-sm-block" />
            </div>
          </template>
        </div>
      </template>
      <template v-if="isBottomZoneComing">
        <div class="row allResultsRow">
          <div class="col-sm resultsCol">
            <div class="allResults">
              <b>All Results</b>
            </div>
          </div>
        </div>

        <div class="rateTable">
          <div style="cursor:default;" v-for="(account, index) in bottomZoneAccounts" v-bind:key="index">
            <rate-table-row
              :account="account"
              :ad="filterPlacement(account.clickUrl)"
              :isWp="isWp"
              :labelCTAButton="labelCTAButton"
              :CTAButtonColor="CTAButtonColor"
              :showDepositAmountAndEstEarning="showDepositAmountAndEstEarning"
              :showAdCopy="showAdCopy"
              :frictionLevel="frictionLevel"
            ></rate-table-row>
            <hr class="hr-separator d-none d-sm-block" />
          </div>
        </div>
      </template>
    </div>
    <div class="showMoreResults" v-if="moreResults > 0">
      <a
        class="showMoreResultsText"
        v-if="showMoreResultsVisible"
        v-on:click="showMoreResults()"
      >Show {{moreResults}} More Results</a>
      <span v-else>Loading...</span>
    </div>

    <rate-table-bank-modal :account="selectedAccount" :ad="filterPlacement(selectedAccount.clickUrl)"></rate-table-bank-modal>
    <rate-table-sort-modal :filter="filter" :showFilters="showFilters" :showSortFilter="showSortFilter" :showRegionFilter="showRegionFilter"></rate-table-sort-modal>
    <rate-table-friction-modal :frictionLevel="frictionLevel" :placement="selectedAd" :CTAButtonColor="CTAButtonColor"></rate-table-friction-modal>
    <ad-disclosure-modal v-if="showAdDisclosure"></ad-disclosure-modal>
  </div>
</template>
<script lang="ts">
import Vue, { defineComponent, defineAsyncComponent } from "vue";
import RateTableRow from "./rate-table-row.vue";
import apiClient from "../../services/apiClient";
import analytics from "../../services/analytics";
import sessionCookie from "../../services/sessionStart";
import {get as getCookie, set as setCookie} from "es-cookie";
import "../../utils/filters";
import utils from '../../utils/utils';
import adDisclosure from "../../components/ad-disclosure-tooltip.vue"
import howDaGetPaid from "../../components/how-da-get-paid.vue"
import constants from '../../common/constants'

export default defineComponent({
  components: {
    "rate-table-row": RateTableRow,
    "rate-table-bank-modal": defineAsyncComponent(() => import(/* webpackChunkName: "chunk-rateTable" */ "./rate-table-bank-modal.vue")),
    "rate-table-sort-modal": defineAsyncComponent(() => import(/* webpackChunkName: "chunk-rateTable" */ "./rate-table-sort-modal.vue")),
    "rate-table-friction-modal": defineAsyncComponent(() => import(/*webpackChunkName: "chunk-rateTable" */ "../shared/rate-table-friction-modal.vue")),
    "ad-disclosure-modal": defineAsyncComponent(() => import(/*webpackChunkName: "chunk-rateTable" */"../../components/ad-disclosure-modal.vue")),
    "ad-disclosure": adDisclosure,
    "how-da-get-paid": howDaGetPaid
  },
  data: function() {
    return {
      response: {} as RateTable.Response,
      selectedAccount: {} as RateTable.Account,
      selectedAd: {} as AdPlacement,
      sort: "default",
      numPlacements: 0,
      showMoreResultsVisible: true,
      firstLoadHasSponsored: false,
      accountLimit: 15,
      firstTimeLoad: true,
      showAdDisclosure: false,  
      addisclosureText: constants.AD_DISCLOSURE_CONTENT.replace('[dateNow]', new Date().toLocaleDateString()),    
    };
  },
  props: {
    filter: Object,
    zoneKeys: String,
    isWp: Boolean,
    labelCTAButton: String,
    CTAButtonColor: String,
    showFilters: Boolean,
    showDepositAmountAndEstEarning: Boolean,
    showRegionFilter: Boolean,
    showResultsTable: Boolean,
    showAdCopy: Boolean,
    frictionLevel: String
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.getRateTableData();
      }
    }
  },
  computed: {
    sponsoredOnly(): RateTable.Account[] {
      const sponsoredAccounts = this.response.topZone.map(x => x.placements).flat().filter(function(ad) {
        return !ad.nonSponsoredAd;
      });
      const sponsoredAccountIds = sponsoredAccounts.map(function(x) {
        return x.account.id;
      });

      return this.response.topZone.map(x => x.accounts).flat().filter(function(a) {
        return sponsoredAccountIds.some(function(x) {
          return a.id === x
        });
      })
    },
    nonSponsoredOnly(): RateTable.Account[] {
      const nonSponsoredAccounts = this.response.topZone.map(x => x.placements).flat().filter(function(ad) {
        return ad.nonSponsoredAd;
      });
      const nonSponsoredAccountIds = nonSponsoredAccounts.map(function(x) {
        return x.account.id;
      });

      return this.response.topZone.map(x => x.accounts).flat().filter(function(a) {
        return nonSponsoredAccountIds.some(function(x) {
          return a.id === x
        });
      })
    },
    topZoneAccounts(): RateTable.Account[] {
      return this.response.topZone.map(x => x.accounts).flat().filter(function(a) {
        return a.clickUrl !== null;
      });
    },
    bottomZoneAccounts(): RateTable.Account[] {
      return this.response.bottomZone.accounts;
    },
    moreResults: function(): number | undefined {
      if (Object.keys(this.response).length != 0) {
        return this.response.bottomZone.totalAccounts - this.response.bottomZone.accounts.length;
      }
    },
    isTopZoneComing: function(): Boolean {
      return (
        Object.keys(this.response).length != 0 && this.topZoneAccounts.length > 0
      );
    },
    isBottomZoneComing: function(): Boolean {
      return (
        Object.keys(this.response).length != 0 && this.bottomZoneAccounts.length > 0
      );
    },
    showSortFilter: function(): Boolean {
      return this.firstLoadHasSponsored && !this.isLoggedIn();
    },
    isExperienceB: function(): Boolean {
      const qs = window.location.search;
      const urlParams = new URLSearchParams(qs);
      let experienceParam = urlParams.get("experience") || "";
      return experienceParam.toUpperCase() == "B";
    }
  },
  created: function() {
    if (this.isLoggedIn()) {
      this.filter.sort = "apy";
    }

    if(this.isWp){
      this.getRateTableData();
    }else{
      this.getCookieValues();
    }
  },
  methods: {
    async getCookieValues(){    
    
    const stateCookieVal = (await sessionCookie.getStateCode()).geostate || "";
    const dmaCookieVal =  (await sessionCookie.getDmaCode()).geodma || 0;
    
    this.filter.state = stateCookieVal;
    this.filter.dma = dmaCookieVal;

    this.filter.region = getCookie("georegion") || "";
    },
    async getRateTableData() {
      // Request
      var data: RateTable.Request = this.prepareRateTableRequest();

      // Response
      const resp: RateTable.Response = await apiClient.getRateTable(data);
      this.$emit("ratetable-response", resp);
      // Prepare Data
      this.response = resp;
      if(resp.topZone.length > 0){
        this.numPlacements = resp.topZone.map(x => x.totalAccounts).reduce((accumulate, currentValue) => { return accumulate + currentValue });
      }

      // on second load - we're replacing the whole table (not appending to the first load response)
      // So, the impression tracking will be duplicated as both load will return same top and bottom placements
      // We can avoid it atleast for top zone.
      if (this.firstTimeLoad) {
        resp.topZone.forEach(x => analytics.trackAdImpressions(
          x.zoneKeyName,
          x.placements
        ))        
      }

      analytics.trackAdImpressions(
        resp.bottomZone.zoneKeyName,
        resp.bottomZone.placements
      );

      if (this.numPlacements > 0 && !this.firstLoadHasSponsored) {
        this.firstLoadHasSponsored = true;
      }

      this.$emit("data-loaded", true);

      if(this.filter && !this.firstTimeLoad){
        if(this.filter.dma != undefined){
          setCookie("geodma", this.filter.dma);
        }
        if(this.filter.state != undefined){
          setCookie("geostate", this.filter.state);
        }
        if(this.filter.region != undefined){
          setCookie("georegion", this.filter.region);
        }
      }
      if(!this.isWp){
        await apiClient.updateGeoLocation();
      }
      this.firstTimeLoad = false;
    },
    prepareRateTableRequest(): RateTable.Request{
      let productId = 0;
      let clientIpAddress;
      if((window as any).depositAccounts){
        productId = (window as any).depositAccounts.rateTableNew.productId;
        clientIpAddress = (window as any).depositAccounts.rateTableNew.ipAddress;
      }
      let rateTableReqObj: RateTable.Request = {
        SiteId: 1,
        ProductId: parseInt(productId.toString()),
        ZoneKeys: this.zoneKeys,
        IsTopZoneOnly: !this.showResultsTable,
        ClientIpAddress: clientIpAddress,
        UserAgent: navigator.userAgent,
        EsourceId: utils.getESourceId(),
        SortColumn: "apy",
        AccountLimit: this.accountLimit,
        Filter: this.prepareRateTableFilterObject()
      }

      return rateTableReqObj;
    },
    prepareRateTableFilterObject(): RateTable.Request["Filter"] {
      let rateTableFilterObj: RateTable.Request["Filter"];

      let depositAmount = 25000;
      if (this.filter.depositAmount) {
        depositAmount = parseInt(this.filter.depositAmount.toString().replace(/\D/g, ""));
      }
      let dma:number =0;
      rateTableFilterObj = {
        State: this.filter.state,
        Dma: this.filter.dma == -1 ? dma :  parseInt(this.filter.dma),
        DepositAmount: depositAmount,
        IncludeWebOnly: this.filter.availability === "online" || this.filter.availability === "branchAndOnline",
        IncludeLocalBranches: this.filter.availability === "branch" || this.filter.availability === "branchAndOnline",
        IncludeBanks: this.filter.institutionType === "bank" || this.filter.institutionType === "bankAndCredit",
        IncludeCreditUnions: this.filter.institutionType === "credit" || this.filter.institutionType === "bankAndCredit",
        SuppressPlacements: this.filter.sort == "apy" && !this.isWp,
        CreditUnionIndustries: this.filter.selectedUnionOptions.join(",") || null
      };

      return rateTableFilterObj;
    },
    filterPlacement: function(clickUrl: string): AdPlacement | undefined {
      // Placements can uniquely identified with trackedLink.
      // At this point, we do not need to know where it lies (top or bottom). So, Combine it and return the matched placement
      if (Object.keys(this.response).length == 0) {
        return;
      }
      const combinedPlacements: AdPlacement[] = this.response.topZone.map(x => x.placements).flat().concat(
        this.response.bottomZone.placements
      );

      return combinedPlacements.filter(
        (placemment: AdPlacement) => placemment.trackedLink === clickUrl
      )[0];
    },
    showMoreResults() {
      this.accountLimit = 99999;
      this.showMoreResultsVisible = false;
      this.getRateTableData();
    },
    isLoggedIn() {
      const userId = getCookie("userid");
      if (userId) {
        return true;
      }
      return false;
    }
  }
});
</script>
<style lang="scss" scoped>
.tooltipdata{
color: #4a4a4a;
margin-top: 15px !important;
}
</style>